import { createSelector } from '@reduxjs/toolkit';
import { selectRoomsForSale } from 'shared/selectors/jsonQuery';
import { selectRoomsInDealLabel } from './selectRoomsInDealLabel';

export const selectRoomsInDealFilter = createSelector(
  [selectRoomsForSale, selectRoomsInDealLabel],
  ({ gte = null, lte = null }, label) => ({
    label,
    valueMin: gte,
    valueMax: lte,
    min: 1,
    max: 99,
  }),
);
